import { ValueChartItem } from "../Components/PercentValueChart/ValueChart";
import ValueChartData from "../Components/PercentValueChart/ValueChartData";

/**
 * Represents the top language stats data that we receive from the server. This data will be 
 * shown on a graph on the analytics page
*/
export default class TopLanguageStats extends ValueChartData {
    public getChartData(): ValueChartItem[] {
        const datasetSum: number = this.dataset.reduce((carry: number, item: ValueChartItem) => carry += item.value, 0);
        const otherLanguagesSum = this.total - this.other - datasetSum;

        const retval = [
            {
                name: "No Language",
                value: this.other,
                children: [],
            },
            ...this.dataset,
            {
                name: "Other Languages",
                value: otherLanguagesSum,
                children: [],
            },
        ];

        if (otherLanguagesSum === 0) {
            retval.pop();
        }

        return retval;
    }
}
